<roma-mf-accounting-service
  [mode]="selectedPlan"
  [openPlans]="true"
  [updateReason]="updateReason"
  [fromUrl]="fromUrl"
></roma-mf-accounting-service>
